import BasePrevenApiClient from './baseApi'

/**
 * Handles the saved list views of the generic lists (`DjangoList`): the
 * named, private sets of filters, text search, ordering and columns a
 * user saves for one list, shown as tabs above it.
 */
class SavedListViewApi extends BasePrevenApiClient {
  /**
   * Returns a shared api instance
   *
   * @returns {SavedListViewApi} Api shared instance
   */
  static get shared() {
    return super.shared
  }

  _path(suffix = '') {
    return this._getFullPath(`/utilities/api/saved-list-view${suffix}`)
  }

  list(token, listApp, listModel) {
    // GETs are memoized in production builds: the list must always
    // reflect the latest create/update/delete.
    this._clearMemos()
    return this._get(this._path(), {
      authToken: token,
      params: { list_app: listApp, list_model: listModel },
    }).then(({ data }) => data.data)
  }

  create(token, listApp, listModel, name, state) {
    return this._post(
      this._path(),
      { list_app: listApp, list_model: listModel, name, state },
      { authToken: token }
    ).then(({ data }) => data)
  }

  update(token, id, data) {
    return this._put(this._path(`/${id}`), data, { authToken: token }).then(
      ({ data }) => data
    )
  }

  delete(token, id) {
    return this._delete(this._path(`/${id}`), { authToken: token })
  }
}

export default SavedListViewApi
